function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M48,48C21.5,48,0,69.5,0,96s21.5,48,48,48s48-21.5,48-48S74.5,48,48,48z M48,208c-26.5,0-48,21.5-48,48s21.5,48,48,48 s48-21.5,48-48S74.5,208,48,208z M48,368c-26.5,0-48,21.5-48,48c0,26.5,21.5,48,48,48s48-21.5,48-48C96,389.5,74.5,368,48,368z  M496,384H176c-8.9,0-16,7.2-16,16v32c0,8.9,7.2,16,16,16H496c8.9,0,16-7.2,16-16v-32C512,391.2,504.8,384,496,384z M496,63.9H176 c-8.9,0-16,7.2-16,16v32c0,8.9,7.2,16,16,16H496c8.9,0,16-7.2,16-16V80C512,71.1,504.8,63.9,496,63.9z M496,224H176 c-8.9,0-16,7.2-16,16v32c0,8.9,7.2,16,16,16H496c8.9,0,16-7.2,16-16v-32C512,231.2,504.8,224,496,224z"
});

function SvgBulletList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletList);
export default __webpack_public_path__ + "static/media/bulletList.da0d2c11.svg";
export { ForwardRef as ReactComponent };